import { render, staticRenderFns } from "./openHistory.vue?vue&type=template&id=da1ef296&scoped=true"
import script from "./openHistory.vue?vue&type=script&lang=js"
export * from "./openHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1ef296",
  null
  
)

export default component.exports